import { ButtonProps } from '@mui/material/Button'
import Typography from '@mui/material/Typography'

import { ButtonBase } from './Button.styles'

export function Button({ label, ...props }: { label?: string } & ButtonProps) {
  return <ButtonBase {...props}>{label && <Typography variant="body">{label}</Typography>}</ButtonBase>
}
